import React, { useState } from "react";
import moment from "moment";

const INVALID_METRIC_MESSAGE = "Ingresa un número válido o deja el campo vacío.";

function parseMetric(value) {
  if (value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

const ManualHealthDataForm = ({
  userName,
  onSubmit,
  onCancel,
  isSaving,
  errorMessage,
}) => {
  const [date, setDate] = useState(() => moment().format("YYYY-MM-DD"));
  const [glucose, setGlucose] = useState("");
  const [bloodPressure, setBloodPressure] = useState("");
  const [validationError, setValidationError] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const normalizedGlucose = parseMetric(glucose);
    const normalizedBloodPressure = parseMetric(bloodPressure);
    if (normalizedGlucose === undefined || normalizedBloodPressure === undefined) {
      setValidationError(INVALID_METRIC_MESSAGE);
      return;
    }

    setValidationError(null);
    onSubmit({
      date,
      glucose: normalizedGlucose,
      bloodPressure: normalizedBloodPressure,
    });
  };

  return (
    <form
      onSubmit={handleSubmit}
      onClick={(event) => event.stopPropagation()}
      className="rounded-xl border border-[#007FB4]/20 bg-white/80 p-4 space-y-3"
      aria-label={`Registrar datos de ${userName}`}
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-slate-400">Registrar datos</p>
          <p className="text-sm font-semibold text-[#1D1F3F]">{userName}</p>
        </div>
        <span className="text-xs font-medium text-slate-500">Registro diario</span>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <label className="flex flex-col gap-1 text-xs font-semibold text-slate-600">
          Fecha
          <input
            type="date"
            aria-label="Fecha"
            value={date}
            onChange={(event) => setDate(event.target.value)}
            disabled={isSaving}
            required
            className="h-10 rounded-xl border border-slate-200 bg-white px-3 text-sm font-medium text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#007FB4]/40"
          />
        </label>
        <label className="flex flex-col gap-1 text-xs font-semibold text-slate-600">
          Glucosa
          <input
            type="number"
            step="any"
            inputMode="decimal"
            aria-label="Glucosa"
            value={glucose}
            onChange={(event) => setGlucose(event.target.value)}
            disabled={isSaving}
            placeholder="Opcional"
            className="h-10 rounded-xl border border-slate-200 bg-white px-3 text-sm font-medium text-slate-700 placeholder-slate-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#007FB4]/40"
          />
        </label>
        <label className="flex flex-col gap-1 text-xs font-semibold text-slate-600">
          Presión arterial
          <input
            type="number"
            step="any"
            inputMode="decimal"
            aria-label="Presión arterial"
            value={bloodPressure}
            onChange={(event) => setBloodPressure(event.target.value)}
            disabled={isSaving}
            placeholder="Opcional"
            className="h-10 rounded-xl border border-slate-200 bg-white px-3 text-sm font-medium text-slate-700 placeholder-slate-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#007FB4]/40"
          />
        </label>
      </div>

      {(validationError || errorMessage) && (
        <p className="text-xs font-medium text-red-600" role="alert">
          {validationError || errorMessage}
        </p>
      )}

      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          disabled={isSaving}
          className="h-9 rounded-xl border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
        >
          Cancelar
        </button>
        <button
          type="submit"
          disabled={isSaving}
          className="h-9 rounded-xl bg-[#1D1F3F] px-4 text-sm font-semibold text-white transition-colors hover:bg-[#2e3160] disabled:cursor-not-allowed disabled:opacity-60"
        >
          {isSaving ? "Guardando..." : "Guardar"}
        </button>
      </div>
    </form>
  );
};

export default ManualHealthDataForm;

export { parseMetric };
